// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"e7e0af4b","319":"acd1d4b7","338":"82971f7f","374":"57152a3f","584":"94e84e45","660":"7d5b86a5","666":"ca56513b","718":"337d7cfb","720":"e7d518af","728":"d702c54d","773":"fc766291"}[chunkId] + ".chunk.js";
};